export default __webpack_public_path__ + "static/media/Operational.705093d9.png";